import { gql } from '@apollo/client';

export const UPDATE_FRIST_GELESEN = gql`
  mutation navigation_updateFristGelesen(
    $input: navigation_updateFristGelesenInput!
  ) {
    navigation_updateFristGelesen(input: $input)
  }
`;
